import React, { useState } from 'react';
import { CButton, CForm, CFormInput, CFormLabel, CFormSelect, } from '@coreui/react'
import Swal from "sweetalert2"
import axios from 'axios'
import ReactLoading from 'react-loading';
import { bebidasFijas } from './bebidasFijas'

function Input({ label, value, set }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '10px' }}>
            <CFormLabel style={{ fontSize: '10px' }}>{label}</CFormLabel>
            <CFormInput maxLength={30} style={{ "maxWidth": "400px", minWidth: "300px" }} value={value} className='col' type="text" onChange={(e) => { set(e.target.value) }} />
        </div>
    )
}

function ImgInput({ handleFile, previewURL, id }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', gap: '10px' }}>
            <input type="file" style={{ display: 'none' }} id="upload" onChange={(e) => handleFile(e)} />
            <label htmlFor="upload" style={{
                display: 'inline-block', padding: '10px 15px', backgroundColor: 'rgb(118, 133, 161)',
                color: 'white', borderRadius: '5px', cursor: 'pointer',
            }}><i className="fa-solid fa-cloud-arrow-up"></i> Imagen de bebida</label>

            {previewURL ?
                <img src={previewURL} alt="Preview" style={{ maxWidth: '10vh', maxHeight: '10vh', objectFit: 'cover', borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.1)', }} />
                :
                <img src={`https://res.cloudinary.com/activecode/image/upload/f_auto,q_auto/bebbo/logo/logo${id}.jpg?${Date.now()}`} alt="Preview" style={{ maxWidth: '10vh', maxHeight: '10vh', objectFit: 'cover', borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.1)', }} />
            }
        </div>
    )
}

function InsertBebida({ setVisible2, bebidas, setBebidas, bebidasOG, setBebidasOG, user1, allDrinks }) {
    let [loading, setLoading] = useState(false)
    let [nombre, setNombre] = useState('')
    let [precio, setPrecio] = useState('')
    let [tipo, setTipo] = useState('')
    let [descripcion, setDescripcion] = useState('')
    let [sabor, setSabor] = useState('')
    let [imagen, setImagen] = useState(null)
    let [progress, setProgress] = useState(0)
    let [previewURL, setPreviewURL] = useState(null);
    let [propia, setPropia] = useState(false)
    let [bebidaSeleccionada, setBebidaSeleccionada] = useState('')

    function handleFile(e) {
        setImagen(e.target.files[0])
        let file = e.target.files[0];
        if (file) { setPreviewURL(URL.createObjectURL(e.target.files[0])); }
    }

    function validarImagen(imagen) {
        if ((imagen.type !== "image/jpeg") || imagen.size > 400000) { // si el archivo pesa mas de 400kb y es tipo diferente a .jpg
            Swal.fire({
                icon: "error",
                title: "Verifica tu imagen",
                text: "Solo se permiten imágenes tipo .jpg y máximo de 400kb.",
                footer: `Esta es de tipo .${imagen.type.split("/")[1]} y pesa ${(imagen.size / 1024).toFixed(2)}kb.`,
                confirmButtonText: "Entendido",
                confirmButtonColor: "rgb(118, 133, 161)",
            })
            return false;
        }
        return true;
    }

    async function subirImagenACloudinary(archivo, nombreImagen, folder, tags) {
        if (!(validarImagen(archivo))) { // si la imagen es inválida
            throw new Error("Imagen inválida");
        }

        return new Promise((resolve, reject) => {
            let img = new Image();
            img.src = URL.createObjectURL(archivo);

            img.onload = async () => {
                if (false) {
                    // if (img.width < 300 || img.height < 300) { // si la imagen mide mínimo 300x300
                    Swal.fire(`La imagen debe medir mínimo 300x300px. Esta tiene ${img.width}x${img.height}`);
                    reject();
                } else {
                    let formData = new FormData();
                    formData.append("file", archivo);
                    formData.append("upload_preset", "upload_bebbo_restaurante");
                    formData.append("user", tags);
                    formData.append("folder", folder);
                    formData.append("public_id", nombreImagen);

                    try {
                        let res = await axios.post(
                            `${process.env.REACT_APP_BackURL}/upMedia`,
                            formData,
                            {
                                onUploadProgress: (e) => {
                                    let percent = Math.round((e.loaded * 100) / e.total);
                                    setProgress(percent);
                                }
                            }
                        );
                        resolve(res.data.secure_url);
                    } catch (err) {
                        reject(err);
                    }
                }
            };
        });
    };

    async function handleSubmit() {

        if (!nombre || !precio || !tipo) {
            Swal.fire("Todos los campos son obligatorios");
            return;
        }

        if (descripcion.length > 30) {
            Swal.fire("La descripcion de la bebida debe tener máximo 30 caracteres");
            return;
        }

        if (imagen) {
            // Validar tipo y tamaño
            if (imagen.type !== "image/jpeg" || imagen.size > 400000) {
                Swal.fire("Solo se permiten imágenes .jpg de menos de 400kb.");
                return;
            }
        }

        try {
            setLoading(true);

            let data = {
                name: nombre,
                price: precio,
                type: tipo,
                description: descripcion,
                flavor: sabor,
            };

            let response = await axios.post(`${process.env.REACT_APP_BackURL}/insertDrink`, data);

            let mongoID = response.data.data._id;

            if (imagen) {

                let folderImg = 'bebbo/drinks'

                let imageUrl = await subirImagenACloudinary(imagen, `drink${mongoID}`, folderImg, mongoID);

                response.data.data.img = imageUrl;
            }

            let restauranteActualizado = await axios.post(`${process.env.REACT_APP_BackURL}/insertDrinkToRestaurant?id=${user1.id}&idDrink=${mongoID}`);

            setBebidas([...bebidas, response.data.data]);
            setBebidasOG([...bebidasOG, response.data.data]);

            Swal.fire('Bebida registrada con éxito');
        } catch (err) {
            console.error(err);
            Swal.fire('Ocurrió un error al registrar o subir la imagen.');
        } finally { // En cualquier caso
            setLoading(false);
            setVisible2(false);
        }
    };

    return (
        <>
            <h3 style={{ 'textAlign': 'center' }}>Nueva bebida</h3>

            <CForm>

                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "10px" }}>
                    <CFormLabel style={{ fontSize: '10px' }}>Tipo de bebida</CFormLabel>
                    <CFormSelect value={tipo} style={{ maxWidth: '300px', textAlign: 'center', marginBottom: '10px' }} onChange={async (e) => { setTipo(e.target.value); setPropia(false); setNombre(''); setBebidaSeleccionada(''); setPreviewURL(null); setImagen(null); }}>
                        <option value="" disabled hidden>Selecciona una categoria</option>
                        {
                            bebidasFijas.sort((a, b) => a.tipo.localeCompare(b.tipo)).map((drink) => {
                                return (
                                    <option key={drink.tipo} value={drink.tipo}>{drink.tipo}</option>
                                )
                            })
                        }
                    </CFormSelect>

                    {
                        tipo != '' &&
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <CFormLabel style={{ fontSize: '10px' }}>Bebida</CFormLabel>
                            <CFormSelect value={bebidaSeleccionada} style={{ maxWidth: '300px', textAlign: 'center' }}
                                onChange={async (e) => {

                                    const value = e.target.value

                                    setNombre(value)
                                    setBebidaSeleccionada(value)
                                    setPropia(false)

                                    if (value === 'sinNombre') {
                                        setPropia(true)
                                        setPreviewURL(null)
                                        setImagen(null)
                                        return
                                    }

                                    let item = bebidasFijas
                                        .find(d => d.tipo === tipo)
                                        ?.opciones.find(d => d.nombre === value)

                                    if (!item) return

                                    if (!item.imagen) {
                                        setPreviewURL(null)
                                        setImagen(null)
                                        return
                                    }

                                    try {

                                        const res = await fetch(item.imagen)

                                        if (!res.ok) throw new Error("No se encontró la imagen")

                                        const blob = await res.blob()

                                        const file = new File([blob], `${item.imagen}.jpg`, { type: blob.type })

                                        const preview = URL.createObjectURL(file)

                                        setPreviewURL(preview)
                                        setImagen(file)

                                    } catch (err) {
                                        console.error("Error cargando imagen:", err)
                                        setPreviewURL(null)
                                        setImagen(null)
                                    }

                                    // esto era para hacerlo con las imagenes de cloudinary
                                    // const item = allDrinks.find(d => d._id === e.target.value)

                                    // setNombre(item.name)
                                    // setPrecio(item.price)
                                    // setTipo(item.type)
                                    // setDescripcion(item.description)
                                    // setSabor(item.flavor)

                                    // const url = `https://res.cloudinary.com/activecode/image/upload/f_auto,q_auto/bebbo/drinks/drink${item._id}.jpg`

                                    // setPreviewURL(url)

                                    // try {
                                    //     const res = await fetch(url)
                                    //     const blob = await res.blob()
                                    //     const file = new File([blob], `drink_${item._id}.jpg`, { type: "image/jpeg" })

                                    //     setImagen(file)
                                    // } catch (err) {
                                    //     console.error("Error cargando imagen:", err)
                                    //     setImagen(null) // importante para evitar errores
                                    // }
                                }}
                            >
                                <option value="" disabled hidden>Selecciona una bebida</option>
                                {
                                    bebidasFijas.filter((drink) => drink.tipo == tipo)[0]?.opciones.sort((a, b) => a.nombre.localeCompare(b.nombre)).map((drink) => {
                                        return (
                                            <option key={drink.nombre} value={drink.nombre}>{drink.nombre}</option>
                                        )
                                    })
                                }
                                <option key={'sinNombre'} value={'sinNombre'}>Añadir una bebida ✏️</option>
                            </CFormSelect>
                        </div>
                    }
                </div>


                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

                    {
                        propia &&
                        <Input label='Nombre' value={nombre == 'sinNombre' ? '' : nombre} set={setNombre} />
                    }

                    <Input label='Precio' value={precio} set={setPrecio} />

                    {/* <Input label='Descripcion' value={tipo} set={setTipo} /> */}

                    <Input label='Descripcion (opcional, máximo 30 caracteres)' value={descripcion} set={setDescripcion} />

                    {/* <Input label='Sabor' value={sabor} set={setSabor} /> */}

                    <br />

                    <ImgInput handleFile={handleFile} previewURL={previewURL} id={user1.id} />

                    <span style={{ fontWeight: "bold", fontSize: "15px", marginTop: "10px" }}>La imágenes deben ser tipo .jpg y máximo 400kb</span>

                </div>

            </CForm>

            <br />

            <div>
                {
                    loading && progress > 0 && progress < 1000 ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: '20px' }}>
                            <ReactLoading type={'spin'} color={'cornflowerblue'} height={'3vw'} width={'3vw'} />
                            <span style={{ fontSize: '20px', fontWeight: 'bold', color: 'cornflowerblue' }}>{progress}%</span>
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <CButton style={{ paddingInline: '25px' }} color="danger" onClick={() => { setVisible2(false) }}>Cancelar</CButton>
                            <CButton style={{ paddingInline: '25px' }} color="success" onClick={() => { handleSubmit() }}>Guardar</CButton>
                        </div>
                }
            </div>
        </>
    );
}

export default InsertBebida
